// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../pr6433-npm11211-20261015/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../pr6433-npm11211-20261015/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.highPriceDialog .header {
  display: flex;
  flex-direction: row;
  gap: 1rem;
  align-items: center;
  border: 1px solid var(--alert-danger);
  background-color: var(--alert-danger-opacity);
  border-radius: var(--border-radius);
  color: var(--alert-danger);
}
.highPriceDialog .header i {
  font-size: var(--h1);
}
.highPriceDialog .header p {
  font-weight: bold;
  font-size: var(--h2);
  margin: 0;
}`, "",{"version":3,"sources":["webpack://./src/app/cp/orders/order-lineitems/order-lineitems.component.scss"],"names":[],"mappings":"AACI;EACI,aAAA;EACA,mBAAA;EACA,SAAA;EACA,mBAAA;EACA,qCAAA;EACA,6CAAA;EACA,mCAAA;EACA,0BAAA;AAAR;AACQ;EACI,oBAAA;AACZ;AACQ;EACI,iBAAA;EACA,oBAAA;EACA,SAAA;AACZ","sourcesContent":[".highPriceDialog {\n    .header{\n        display: flex;\n        flex-direction: row;\n        gap: 1rem;\n        align-items: center;\n        border:1px solid var(--alert-danger);\n        background-color:var(--alert-danger-opacity);\n        border-radius: var(--border-radius);\n        color:var(--alert-danger);\n        i{\n            font-size: var(--h1);\n        }\n        p{\n            font-weight: bold;\n            font-size: var(--h2);\n            margin: 0;\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
